import filter from 'lodash/filter.js';
import isEmpty from 'lodash/isEmpty.js';
import compact from 'lodash/compact.js';

export const hasErrorMessage = (opt) =>
  opt.messages.find((message) => message.messageType === 'Error');

const isEnabledAndIncluded = (choice, choicesForOption) =>
  !choice.isDisabled && choicesForOption.includes(choice.id);

export const hasError = (options, choices) => {
  // get options that have at least one message AND at least one enabled choice
  const opts = filter(
    options,
    (ooo) =>
      !isEmpty(ooo.messages) &&
      !isEmpty(filter(choices, (ccc) => isEnabledAndIncluded(ccc, ooo.choices)))
  );
  if (opts.length > 0) {
    // are any of the messages of type 'Error'
    return !!opts.find(hasErrorMessage);
  }
  return false;
};

export const getMappedSkus = (skuMap) =>
  compact([skuMap.sku, ...skuMap.subSkus.map((sub) => sub.sku)]);

export const getSelectedChoices = (options, choices) =>
  filter(choices, (choice) => options[choice.optionId].isActive && choice.isSelected);

export const getPriceData = (originalPrice, specialPrice) => ({
  originalPrice,
  specialPrice: specialPrice || originalPrice,
  isLowerPrice: specialPrice ? specialPrice < originalPrice : false,
});
